export const listItemToggle = (list: string[], value: string) => {
    if (list.includes(value)) {
        return list.filter((listItem) => listItem !== value);
    }

    return [...list, value];
};
